// extracted by mini-css-extract-plugin
export default {"icon":"ConsultantProject_icon__rObzA","txtWrapper":"ConsultantProject_txtWrapper__YY2+f","company":"ConsultantProject_company__kxnEf","wrapper":"ConsultantProject_wrapper__R1QZJ"};